// @flow
export const PROVIDER_IS_NOT_IN_LIST = "-99999";
export const PROVIDER_EXTERNAL_ID_IS_NOT_IN_LIST = -99999;
export const TARIFF_IS_NOT_IN_LIST = -99999;
